import React from 'react';

class HeadHOC extends React.Component {
	componentDidMount() {
		this.props.getHatTargetCoords(this.refs.hatTarget);
	}
}

class Head0 extends HeadHOC {
	render() {
		return (
			<g>
				<circle ref="hatTarget" cx="198.3777466" cy="115.3500366" />
				<path className="fill" d="M297.5195312,174.7324219l-11.168396,0.6960449
					c0.8058472-22.6686401-4.857666-70.8167725-12.9073486-90.3704834c-2.0126953-6.411499-10.1627808-10.1656494-15.6678467-5.7921143
					l-0.000061,0.000061c-10.5443115,6.0974731-23.5308838,15.9562378-33.8678589,25.4852905
					c-7.9797363-2.2817383-16.4360352-3.5415039-25.1954956-3.5415039c-8.7077637,0-17.1159058,1.2452393-25.0541992,3.5014648
					c-10.3299561-9.5166016-23.2952881-19.3563843-33.8247681-25.4452515v-0.000061
					c-5.5050659-4.3735352-13.6551514-0.6193848-15.6679077,5.7921143c-8.0095825,19.4562988-13.65448,67.2142944-12.9168091,90.0214233
					c-0.0073242,0.1578369-0.0165405,0.3156738-0.022522,0.4735107l-13.1647949-0.8204956
					c-2.5009766-0.1567383-4.6171875,1.7314453-4.7714844,4.2114258c-0.1542969,2.4804688,1.7304688,4.6166992,4.2109375,4.7709961
					l14.1262817,0.8803711c0.2800903,2.1012573,0.6940918,4.1260986,1.227478,6.0805054l-10.6750488,3.6392212
					c-2.3525391,0.8017578-3.609375,3.3588867-2.8076172,5.7114258c0.6386719,1.8710938,2.3867188,3.0493164,4.2597656,3.0493164
					c0.4814453,0,0.9707031-0.078125,1.4521484-0.2421875l11.0324097-3.7610474
					c1.1381836,2.2088013,2.4599609,4.3027344,3.9556274,6.2821655l-7.3161621,6.0423584
					c-1.9169922,1.5825195-2.1875,4.4189453-0.6044922,6.3354492c0.8896484,1.0771484,2.1757812,1.6342773,3.4726562,1.6342773
					c1.0087891,0,2.0244141-0.3378906,2.8623047-1.0302734l7.6834106-6.3457031
					c15.7351685,14.2298584,42.3538818,20.7584229,72.5427856,20.7584229c29.62677,0,55.8122559-6.2897339,71.6497803-19.9735107
					l6.7333984,5.560791c0.8388672,0.6928711,1.8535156,1.0302734,2.8623047,1.0302734
					c1.296875,0,2.5830078-0.5571289,3.4726562-1.6347656c1.5830078-1.9160156,1.3125-4.7524414-0.6044922-6.3349609
					l-6.1897583-5.1117554c1.6690063-2.0933228,3.1382446-4.319458,4.3961792-6.6782227l9.4644775,3.2265015
					c0.4814453,0.1640625,0.9707031,0.2421875,1.4521484,0.2421875c1.8730469,0,3.6210938-1.1782227,4.2597656-3.0493164
					c0.8017578-2.3525391-0.4550781-4.909668-2.8076172-5.7114258l-8.9893188-3.0645142
					c0.6224976-2.1658936,1.09198-4.4221802,1.399353-6.7709351l12.2686768-0.7646484
					c2.4804688-0.1542969,4.3652344-2.2905273,4.2109375-4.7709961
					C302.1357422,176.4638672,300.0263672,174.5727539,297.5195312,174.7324219z"/>
				<path className="fill--face" d="M204.0471954,180.5730591c2.3025818,0,3.6375275,2.2151337,2.2914124,3.8022461l-4.6143188,5.3463898
					c-1.1341095,1.2987366-3.424881,1.2919159-4.5482483-0.0135498l-4.5774536-5.3194733
					c-1.3641815-1.5853271-0.0314941-3.8156128,2.2799988-3.8156128H204.0471954z"/>
			</g>
		);
	}
}

class Head1 extends HeadHOC {
	render() {
		return (
			<g>
				<circle ref="hatTarget" cx="198.3777466" cy="115.3500366" />
				<path className="fill" d="M306.0224609,194.3149414l-10.5822754-3.607666c-0.0405273-2.0932617-0.2005005-4.2236328-0.4882812-6.3847656
					l9.7492676-0.607666c2.4804688-0.1542969,4.3652344-2.2905273,4.2109375-4.7709961s-2.2724609-4.3725586-4.7714844-4.2114258
					l-11.0126343,0.6862793c-1.5087891-5.5307617-3.7248535-11.1491699-6.5653076-16.6948242
					c-1.3328857-24.520752-6.2202759-58.1230469-12.6188965-73.6657715
					c-2.0126953-6.4116211-10.1627808-10.1657715-15.6678467-5.7922363h-0.000061
					c-10.6514282,6.1594238-23.7930298,16.1567383-34.1798706,25.7751465
					c-7.9381104-2.4560547-16.2775879-3.8312988-24.8834839-3.8312988c-8.5559692,0-16.848877,1.3588867-24.7456055,3.7883301
					c-10.3796387-9.6054688-23.4979248-19.5820312-34.1333618-25.7321777l0,0
					c-5.5050659-4.3735352-13.6551514-0.6193848-15.6679077,5.7922363
					c-6.3637695,15.458252-11.2327271,48.7800293-12.5968018,73.2648926c-2.968689,5.7312012-5.2705688,11.5449219-6.8161621,17.2626953
					l-13.6911621-0.8532715c-2.5117188-0.1591797-4.6181641,1.7314453-4.7714844,4.2114258
					c-0.1542969,2.4804688,1.7304688,4.6166992,4.2109375,4.7709961l12.4507446,0.7758789
					c-0.2322998,1.7822266-0.3815918,3.5444336-0.4459839,5.28125l-13.3260498,4.5429688
					c-2.3525391,0.8017578-3.609375,3.3588867-2.8076172,5.7114258c0.6386719,1.8710938,2.3867188,3.0493164,4.2597656,3.0493164
					c0.4814453,0,0.9707031-0.078125,1.4521484-0.2421875l10.9870605-3.7456055
					c0.3132324,1.8291016,0.7437134,3.5622559,1.2938232,5.1989746l-8.6090088,7.1101074
					c-1.9169922,1.5825195-2.1875,4.4189453-0.6044922,6.3354492c0.8896484,1.0771484,2.1757812,1.6342773,3.4726562,1.6342773
					c1.0087891,0,2.0244141-0.3378906,2.8623047-1.0302734l7.107666-5.8701172
					c13.6983032,18.6286621,48.8760376,20.2828369,90.1185303,20.2828369c40.2109375,0,74.6560669-1.572876,89.0502319-18.9168701
					l5.4540405,4.5041504c0.8388672,0.6928711,1.8535156,1.0302734,2.8623047,1.0302734
					c1.296875,0,2.5830078-0.5571289,3.4726562-1.6347656c1.5830078-1.9160156,1.3125-4.7524414-0.6044922-6.3349609
					l-6.5224609-5.3864746c0.7577515-1.8815918,1.3534546-3.8933105,1.7750244-6.046875l8.418335,2.869873
					c0.4814453,0.1640625,0.9707031,0.2421875,1.4521484,0.2421875c1.8730469,0,3.6210938-1.1782227,4.2597656-3.0493164
					C309.6318359,197.6738281,308.375,195.1166992,306.0224609,194.3149414z"/>
				<path className="fill--face" d="M204.0471954,180.5730591c2.3025818,0,3.6375275,2.2151337,2.2914124,3.8022461l-4.6143188,5.3463898
					c-1.1341095,1.2987366-3.424881,1.2919159-4.5482483-0.0135498l-4.5774536-5.3194733
					c-1.3641815-1.5853271-0.0314941-3.8156128,2.2799988-3.8156128H204.0471954z"/>		</g>
		);
	}
}

function Heads(props) {
	let heads = {
		Head0: Head0,
		Head1: Head1
	};

	let propHead = 'Head' + props.head;

	let Head = heads[propHead];

	return <Head {...props} />;
}

export default Heads;



// WEBPACK FOOTER //
// ./src/components/Global/Pet/Cat/Heads.js